import React from "react";
import { Dropdown, Icon } from "aible";

import styles from "./style.module.css";

import { ACCOUNT_LOGOS } from "containers/Accounts/reducer";

export default class AccountSelector extends React.Component {
  createOption(account) {
    return {
      label: <OptionItem data={account} />,
      value: account.id,
      data: account
    };
  }

  render() {
    const { accounts, selectedAccount, onChange, removeAccountTypes, isLocked } = this.props;
    const retAccounts = accounts
      .map((account) => this.createOption(account))
      .sort((a1, a2) => {
        if (a1?.data?.type === "GCP" && a2?.data?.type !== "GCP") {
          return -1;
        }
        if (a2?.data?.type === "GCP" && a1?.data?.type !== "GCP") {
          return 1;
        }
        if (a2?.data?.type === a1?.data?.type) {
          return a1?.data?.name > a2?.data?.name ? 1 : a1?.data?.name < a2?.data?.name ? -1 : 0;
        }
        return a1?.data?.type > a2?.data?.type ? 1 : a1?.data?.type < a2?.data?.type ? -1 : 0;
      });
    if (!retAccounts.length) {
      return (
        <div>
          {`No${removeAccountTypes?.length ? " valid" : ""} account found. Please link a ${removeAccountTypes?.length ? removeAccountTypes.join(", ") : "cloud"} account`}
        </div>
      );
    }
    let retIsLocked = isLocked;
    if (retIsLocked === undefined) {
      retIsLocked =
        selectedAccount &&
        selectedAccount.id &&
        retAccounts?.length === 1 &&
        retAccounts[0]?.data?.id === selectedAccount?.id;
    }

    return (
      <Dropdown
        placeholder={"Select an account"}
        selected={selectedAccount && selectedAccount.id}
        options={retAccounts}
        onChange={(option) => onChange && onChange(option.data)}
        isLocked={retIsLocked}
      />
    );
  }
}

class OptionItem extends React.Component {
  render() {
    const { data } = this.props;
    let type = data.type;

    return (
      <div className={styles.accountSelectOption}>
        <div className={styles.accountSelectLabel}>{data.name}</div>
        <div className={styles.accountSelectIcon}>
          <Icon src={ACCOUNT_LOGOS[type]} alt={type} />
        </div>
      </div>
    );
  }
}
